module.exports = __webpack_public_path__ + "static/media/hero.0f4eae11.png";